import React from 'react';
import { 
  HelpCircle, 
  TrendingUp, 
  CreditCard, 
  Percent, 
  FileText, 
  Clock, 
  Shield, 
  Landmark 
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: CreditCard,
      title: 'Выбор компаний',
      description: 'Инвестируйте в финансово стабильные компании с историей регулярных выплат дивидендов.'
    },
    {
      icon: Percent,
      title: 'Дивидендная доходность',
      description: 'Слишком высокая дивидендная доходность может сигнализировать о проблемах компании.'
    },
    {
      icon: Clock,
      title: 'Периодичность',
      description: 'Обращайте внимание на экс-дивидендную дату, для получения выплаты акции должны быть куплены заранее.'
    },
    {
      icon: FileText,
      title: 'Дивидендная политика',
      description: 'Изучите политику выплат компании, чтобы понимать какую часть прибыли она направляет на дивиденды.'
    },
    {
      icon: Shield,
      title: 'Налогообложение',
      description: 'Дивиденды по российским акциям облагаются НДФЛ по ставке 13% (для резидентов РФ).'
    },
    {
      icon: TrendingUp,
      title: 'Реинвестирование',
      description: 'Вложение полученных дивидендов в покупку новых акций увеличивает будущий доход за счет сложного процента.'
    },
    {
      icon: Landmark,
      title: 'Диверсификация',
      description: 'Распределите инвестиции между разными компаниями и секторами для снижения рисков.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-green-500" />
        Советы по дивидендным инвестициям
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-green-700 dark:text-green-300 mb-2">
              Актуальные дивиденды российских компаний
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400 mb-3">
              Для получения актуальной информации о дивидендных выплатах российских компаний, размерах и датах выплат рекомендуем обратиться к специализированным источникам.
            </p>
            <button className="w-full py-1.5 text-xs bg-green-500 text-white rounded hover:bg-green-600 transition-colors">
              Календарь дивидендов
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;